export const CertificateRegistry = `CertificateRegistry/`;
export const Search = CertificateRegistry + 'Search';
export const ScorecardTypesForFieldsMapping = CertificateRegistry + 'ScorecardTypesForFieldsMapping';
export const ValidateCertificateNumberVersion = CertificateRegistry + 'ValidateCertificateNumberVersion';
export const GetLatestPublishedCertificate = CertificateRegistry + 'GetLatestPublishedCertificate/';